import { Component } from '@angular/core';
import { ItemsComponent } from '@common/classes/items.component.abstract';
import { FormProperty } from '@common/components/app-control/app-control.component';
import { ColumnSettings } from '@common/interfaces/column-settings.interface';
import { invoiceListColumns } from 'app/invoice/invoice-helper';
import { InvoiceListModel } from 'app/invoice/models/invoice-list.model';

@Component({
    selector: 'app-invoices',
    templateUrl: './invoices.component.html',
    styleUrl: './invoices.component.scss'
})
export class InvoicesComponent extends ItemsComponent<InvoiceListModel> {
    protected override command: string;
    protected override itemName: string;
    protected override itemCreatePermission: string;
    protected override itemEditPermission: string;
    protected override itemRemovePermission: string;
    protected override dialogProperties: FormProperty<string>[];
    override columns: ColumnSettings[] = invoiceListColumns;
}
